const CHANGE_INBOX = 'leads/inbox/CHANGE';
const FETCH_UNREAD = 'leads/inbox/FETCH_UNREAD';
const FETCH_UNREAD_SUCCEEDED = 'leads/inbox/FETCH_UNREAD_SUCCEEDED';
const FETCH_UNREAD_FAILED = 'leads/inbox/FETCH_UNREAD_FAILED';

export { CHANGE_INBOX, FETCH_UNREAD, FETCH_UNREAD_SUCCEEDED, FETCH_UNREAD_FAILED };
